import React from 'react';
import {Box, IconButton, Tooltip} from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import ImageIcon from '@mui/icons-material/Image';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import LinkIcon from '@mui/icons-material/Link';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import SubjectIcon from '@mui/icons-material/Subject';

const ToolbarButton = ({title, onClick, active, icon}) => (
    <Tooltip title={title}>
        <IconButton onClick={onClick} color={active ? 'primary' : 'default'} size="small">
            {icon}
        </IconButton>
    </Tooltip>
);

const TiptapToolbar = ({editor, onOpenImageUpload, onOpenIconLibrary}) => {
    if (!editor) return null;

    const setLink = () => {
        const currentHref = editor.getAttributes('link').href || '';
        const url = window.prompt('Enter URL', currentHref);

        if (url === null) {
            return;
        }

        if (url.trim() === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
        }

        editor.chain().focus().extendMarkRange('link').setLink({href: url.trim()}).run();
    };

    return (
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5, borderBottom: '1px solid #e0e0e0', p: 1}}>
            <ToolbarButton
                title="Heading 1"
                onClick={() => editor.chain().focus().toggleHeading({level: 1}).run()}
                active={editor.isActive('heading', {level: 1})}
                icon={<LooksOneIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Heading 2"
                onClick={() => editor.chain().focus().toggleHeading({level: 2}).run()}
                active={editor.isActive('heading', {level: 2})}
                icon={<LooksTwoIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Paragraph"
                onClick={() => editor.chain().focus().setParagraph().run()}
                active={editor.isActive('paragraph')}
                icon={<SubjectIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Bold"
                onClick={() => editor.chain().focus().toggleBold().run()}
                active={editor.isActive('bold')}
                icon={<FormatBoldIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Italic"
                onClick={() => editor.chain().focus().toggleItalic().run()}
                active={editor.isActive('italic')}
                icon={<FormatItalicIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Underline"
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                active={editor.isActive('underline')}
                icon={<FormatUnderlinedIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Strike"
                onClick={() => editor.chain().focus().toggleStrike().run()}
                active={editor.isActive('strike')}
                icon={<StrikethroughSIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Bullet List"
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                active={editor.isActive('bulletList')}
                icon={<FormatListBulletedIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Numbered List"
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                active={editor.isActive('orderedList')}
                icon={<FormatListNumberedIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Blockquote"
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
                active={editor.isActive('blockquote')}
                icon={<FormatQuoteIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Divider"
                onClick={() => editor.chain().focus().setHorizontalRule().run()}
                active={false}
                icon={<HorizontalRuleIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Link"
                onClick={setLink}
                active={editor.isActive('link')}
                icon={<LinkIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Upload Image"
                onClick={onOpenImageUpload}
                active={false}
                icon={<ImageIcon fontSize="small"/>}
            />
            <ToolbarButton
                title="Image Library"
                onClick={onOpenIconLibrary}
                active={false}
                icon={<AutoAwesomeMosaicIcon fontSize="small"/>}
            />
        </Box>
    );
};

export default TiptapToolbar;
